/* ==========================================================================
   Lone Bandit — theme.js
   No dependencies. Cart drawer via Shopify Section Rendering API.
   ========================================================================== */

(function () {
  'use strict';

  var routes = (window.LB && window.LB.routes) || {};
  var strings = (window.LB && window.LB.strings) || {};

  /* ---------------------------------------------------------------- utils */

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function announce(msg) {
    var region = $('[data-live-region]');
    if (region) { region.textContent = ''; setTimeout(function () { region.textContent = msg; }, 60); }
  }

  var scrollLock = {
    y: 0,
    on: function () {
      this.y = window.scrollY;
      document.body.classList.add('is-locked');
      document.body.style.top = -this.y + 'px';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    },
    off: function () {
      document.body.classList.remove('is-locked');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, this.y);
    }
  };

  function trapFocus(container) {
    var selectors = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
    function onKey(e) {
      if (e.key !== 'Tab') return;
      var items = $$(selectors, container).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKey);
    return function () { container.removeEventListener('keydown', onKey); };
  }

  /* -------------------------------------------------------------- overlay */

  var overlay = {
    el: null,
    show: function () {
      this.el = this.el || $('[data-overlay]');
      if (!this.el) return;
      this.el.hidden = false;
      requestAnimationFrame(function () { overlay.el.classList.add('is-active'); });
    },
    hide: function () {
      if (!this.el) return;
      this.el.classList.remove('is-active');
      var el = this.el;
      setTimeout(function () { if (!el.classList.contains('is-active')) el.hidden = true; }, 250);
    }
  };

  /* ------------------------------------------------------- panel controller */

  function Panel(el) {
    this.el = el;
    this.isOpen = false;
    this.release = null;
    this.lastFocus = null;
  }

  Panel.prototype.open = function () {
    if (!this.el || this.isOpen) return;
    this.isOpen = true;
    this.lastFocus = document.activeElement;
    this.el.classList.add('is-open');
    this.el.removeAttribute('aria-hidden');
    overlay.show();
    scrollLock.on();
    this.release = trapFocus(this.el);
    var focusTarget = this.el.querySelector('[data-autofocus]') || this.el.querySelector('button, a[href]');
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 120);
  };

  Panel.prototype.close = function () {
    if (!this.el || !this.isOpen) return;
    this.isOpen = false;
    this.el.classList.remove('is-open');
    this.el.setAttribute('aria-hidden', 'true');
    overlay.hide();
    scrollLock.off();
    if (this.release) { this.release(); this.release = null; }
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  Panel.prototype.toggle = function () { this.isOpen ? this.close() : this.open(); };

  var panels = {};

  /* Any [data-panel] that lives inside a section wrapper is trapped in that
     wrapper's stacking context -- .header-section uses position sticky/relative
     plus a z-index, which caps everything inside it below the page overlay no
     matter how high the panel's own z-index is. Parking panels directly on
     <body> is the only reliable escape. */
  function relocatePanels(scope) {
    $$('[data-panel]', scope || document).forEach(function (el) {
      if (el.parentElement === document.body) return;

      var name = el.getAttribute('data-panel');

      // A theme-editor section reload re-renders the panel inside the wrapper,
      // so drop any stale copy already parked on <body> before moving this one.
      $$('body > [data-panel="' + name + '"]').forEach(function (stale) {
        if (stale !== el) stale.remove();
      });

      if (panels[name]) {
        panels[name].close();
        delete panels[name];
      }

      document.body.appendChild(el);
    });
  }

  function getPanel(name) {
    if (panels[name]) return panels[name];
    var el = document.querySelector('[data-panel="' + name + '"]');
    if (!el) return null;
    panels[name] = new Panel(el);
    return panels[name];
  }

  function closeAllPanels() {
    Object.keys(panels).forEach(function (k) { panels[k].close(); });
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-panel-open]');
    if (openBtn) {
      var name = openBtn.getAttribute('data-panel-open');
      var p = getPanel(name);
      if (p) { e.preventDefault(); closeAllPanels(); p.open(); }
      return;
    }
    var closeBtn = e.target.closest('[data-panel-close]');
    if (closeBtn) { e.preventDefault(); closeAllPanels(); return; }
    if (e.target.closest('[data-overlay]')) closeAllPanels();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllPanels();
  });

  /* ----------------------------------------------------------- header size */

  function syncHeaderHeight() {
    var header = $('[data-header]');
    if (!header) return;
    document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
  }

  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;

    // Sticky must sit on the section wrapper Shopify injects, not on .header --
    // a sticky element is confined to its parent's box.
    var wrapper = header.parentElement;
    if (wrapper) {
      wrapper.classList.add('header-section');
      wrapper.classList.toggle('is-sticky', header.classList.contains('header--sticky'));
      wrapper.classList.toggle('is-transparent', header.classList.contains('header--transparent'));
    }

    syncHeaderHeight();
    window.addEventListener('resize', syncHeaderHeight);

    var needsScrollState =
      header.classList.contains('header--transparent') ||
      header.classList.contains('header--condense');

    if (needsScrollState) {
      var threshold = 40;
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          header.classList.toggle('is-scrolled', window.scrollY > threshold);
          ticking = false;
        });
      };
      header.classList.toggle('is-scrolled', window.scrollY > threshold);
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  /* --------------------------------------------------------------- cart api */

  function fetchSections(names) {
    var url = window.location.pathname + '?sections=' + names.join(',');
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); });
  }

  function renderCartSections() {
    var targets = $$('[data-section-refresh]');
    if (!targets.length) return Promise.resolve();
    var names = targets.map(function (el) { return el.getAttribute('data-section-refresh'); });
    var unique = names.filter(function (n, i) { return names.indexOf(n) === i; });

    return fetchSections(unique).then(function (data) {
      targets.forEach(function (el) {
        var name = el.getAttribute('data-section-refresh');
        var html = data[name];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-section-refresh="' + name + '"]');
        if (fresh) el.innerHTML = fresh.innerHTML;
      });
      updateCartCounts(data);
    });
  }

  function updateCartCounts() {
    return fetch(routes.cart + '.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.closest('[data-cart-count-wrap]') && el.closest('[data-cart-count-wrap]').classList.toggle('is-empty', cart.item_count === 0);
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        return cart;
      });
  }

  function addToCart(formData, button) {
    if (button) { button.classList.add('btn--loading'); button.disabled = true; }

    return fetch(routes.cart_add, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
        return renderCartSections().then(function () {
          announce(strings.added || 'Added to cart');
          if (window.LB.cartDrawer) {
            var drawer = getPanel('cart');
            if (drawer) { closeAllPanels(); drawer.open(); }
          } else {
            window.location.href = routes.cart;
          }
        });
      })
      .catch(function (err) {
        var msg = err.message || 'Something went wrong';
        announce(msg);
        var host = button && button.closest('form');
        if (host) {
          var existing = host.querySelector('[data-form-error]');
          if (existing) existing.remove();
          var note = document.createElement('div');
          note.className = 'form-status form-status--error';
          note.setAttribute('data-form-error', '');
          note.textContent = msg;
          host.appendChild(note);
        }
      })
      .finally(function () {
        if (button) { button.classList.remove('btn--loading'); button.disabled = false; }
      });
  }

  function changeLine(key, quantity) {
    return fetch(routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return renderCartSections(); });
  }

  /* --------------------------------------------------------- cart bindings */

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var button = form.querySelector('[type="submit"]');
    addToCart(new FormData(form), button);
  });

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-qty]');
    if (qtyBtn) {
      e.preventDefault();
      var wrap = qtyBtn.closest('.qty');
      var input = wrap && wrap.querySelector('.qty__input');
      if (!input) return;
      var delta = qtyBtn.getAttribute('data-qty') === 'up' ? 1 : -1;
      var next = Math.max(0, parseInt(input.value, 10) + delta);
      var key = input.getAttribute('data-line-key');
      if (key) changeLine(key, next);
      else input.value = Math.max(1, next);
      return;
    }

    var remove = e.target.closest('[data-line-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-line-remove'), 0);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('.qty__input[data-line-key]');
    if (!input) return;
    var q = Math.max(0, parseInt(input.value, 10) || 0);
    changeLine(input.getAttribute('data-line-key'), q);
  });

  /* --------------------------------------------------------- product gallery */

  function initProductGallery(root) {
    var gallery = root.querySelector('[data-product-gallery]');
    var dotsWrap = root.querySelector('[data-gallery-dots]');
    if (!gallery || !dotsWrap) return;

    var figures = $$('figure', gallery);
    var dots = $$('[data-dot-index]', dotsWrap);
    if (!figures.length || !dots.length) return;

    dotsWrap.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-dot-index]');
      if (!dot) return;
      var target = figures[parseInt(dot.getAttribute('data-dot-index'), 10)];
      if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    });

    if (typeof IntersectionObserver === 'undefined') return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var idx = figures.indexOf(entry.target);
        if (idx === -1) return;
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      });
    }, { root: gallery, threshold: 0.6 });

    figures.forEach(function (f) { observer.observe(f); });
  }

  /* -------------------------------------------------------- variant picker */

  function VariantPicker(root) {
    this.root = root;
    this.variants = [];
    this.form = root.querySelector('[data-product-form]');
    this.idInput = root.querySelector('[data-variant-id]');
    this.button = root.querySelector('[data-add-button]');
    this.priceEl = root.querySelector('[data-price]');
    this.skuEl = root.querySelector('[data-sku]');
    this.notifyWrap = root.querySelector('[data-notify-wrap]');
    this.isPreorder = root.getAttribute('data-preorder') === 'true';
    this.preorderLabel = root.getAttribute('data-preorder-label') || 'Pre-order';

    var data = root.querySelector('[data-variant-json]');
    if (data) {
      try { this.variants = JSON.parse(data.textContent); } catch (err) { this.variants = []; }
    }

    this.bind();
    this.update(false);
  }

  VariantPicker.prototype.selectedOptions = function () {
    return $$('[data-option-input]:checked', this.root).map(function (i) { return i.value; });
  };

  VariantPicker.prototype.match = function () {
    var chosen = this.selectedOptions();
    if (!chosen.length) return null;
    return this.variants.filter(function (v) {
      return chosen.every(function (val, i) { return v.options[i] === val; });
    })[0] || null;
  };

  VariantPicker.prototype.markAvailability = function () {
    var self = this;
    var chosen = this.selectedOptions();

    $$('[data-option-group]', this.root).forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-option-index'), 10);
      $$('[data-option-input]', group).forEach(function (input) {
        var probe = chosen.slice();
        probe[idx] = input.value;
        var exists = self.variants.some(function (v) {
          return v.available && probe.every(function (val, i) {
            return i === idx ? v.options[i] === val : (val === undefined || v.options[i] === val);
          });
        });
        var label = input.nextElementSibling;
        if (label) label.classList.toggle('option__value--unavailable', !exists);
      });
    });
  };

  VariantPicker.prototype.update = function (pushState) {
    if (!this.variants.length) return;

    var variant = this.match();
    this.markAvailability();

    if (this.idInput) this.idInput.value = variant ? variant.id : '';

    if (this.button) {
      var label = this.button.querySelector('.btn__label') || this.button;
      if (!variant) {
        this.button.disabled = true;
        label.textContent = strings.unavailable || 'Unavailable';
      } else if (!variant.available) {
        this.button.disabled = true;
        label.textContent = strings.soldOut || 'Sold out';
      } else {
        this.button.disabled = false;
        label.textContent = this.isPreorder
          ? this.preorderLabel
          : (strings.addToCart || 'Add to cart');
      }
    }

    if (variant && this.priceEl && variant.price_html) {
      this.priceEl.innerHTML = variant.price_html;
    }

    if (variant && this.skuEl) {
      this.skuEl.textContent = variant.sku || '';
    }

    if (this.notifyWrap) {
      var needsNotify = !this.isPreorder && !(variant && variant.available);
      this.notifyWrap.hidden = !needsNotify;
      if (!needsNotify) this.notifyWrap.classList.remove('is-open');
    }

    if (variant && variant.featured_media_id) {
      var media = this.root.closest('[data-product-root]') || document;
      var target = media.querySelector('[data-media-id="' + variant.featured_media_id + '"]');
      if (target && typeof target.scrollIntoView === 'function' && window.innerWidth < 990) {
        target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    if (pushState && variant && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
  };

  VariantPicker.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-input]')) self.update(true);
    });
  };

  /* --------------------------------------------------------- collection ui */

  document.addEventListener('click', function (e) {
    var viewBtn = e.target.closest('[data-view-cols]');
    if (!viewBtn) return;
    var grid = $('[data-collection-grid]');
    if (grid) {
      grid.style.setProperty('--cols', viewBtn.getAttribute('data-view-cols'));
      grid.style.setProperty('--cols-tablet', viewBtn.getAttribute('data-view-cols-tablet'));
      grid.style.setProperty('--cols-mobile', viewBtn.getAttribute('data-view-cols-mobile'));
    }
    var group = viewBtn.closest('.collection-toolbar__view');
    if (group) {
      $$('.collection-toolbar__view-btn', group).forEach(function (b) {
        b.classList.toggle('is-active', b === viewBtn);
      });
    }
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-sort-select]')) return;

    /* Rewrite the query string rather than submitting the filter form. That
       form only exists when the drawer has something left to show, so relying
       on it silently broke sorting once product type moved inline. Submitting
       it was also lossy -- it would drop any filter rendered outside the form.
       Editing the URL preserves every active filter either way. */
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.target.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });

  /* -------------------------------------------------------------- carousel */

  document.addEventListener('click', function (e) {
    var prevBtn = e.target.closest('[data-carousel-prev]');
    var nextBtn = e.target.closest('[data-carousel-next]');
    if (!prevBtn && !nextBtn) return;
    var host = (prevBtn || nextBtn).closest('.section');
    var track = host && host.querySelector('[data-carousel]');
    if (!track) return;
    var amount = track.clientWidth * 0.8;
    track.scrollBy({ left: prevBtn ? -amount : amount, behavior: 'smooth' });
  });

  /* ---------------------------------------------------------- notify form */

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-notify-toggle]');
    if (!toggle) return;
    e.preventDefault();
    var wrap = toggle.closest('.product__notify');
    if (wrap) wrap.classList.toggle('is-open');
  });

  /* ------------------------------------------------------------- quick add */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var fd = new FormData();
    fd.append('id', btn.getAttribute('data-quick-add'));
    fd.append('quantity', '1');
    addToCart(fd, btn);
  });

  /* -------------------------------------------------------------- nav drawer */

  function showNavPanel(viewport, target) {
    $$('[data-nav-panel]', viewport).forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-nav-panel') !== target;
    });
  }

  function initNavDrawer() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-panel-open="nav"]')) {
        var nav = getPanel('nav');
        var viewport = nav && nav.el && nav.el.querySelector('[data-nav-viewport]');
        if (viewport) showNavPanel(viewport, 'root');
        return;
      }

      var openBtn = e.target.closest('[data-nav-open]');
      if (openBtn) {
        var vp = openBtn.closest('[data-nav-viewport]');
        if (vp) showNavPanel(vp, openBtn.getAttribute('data-nav-open'));
        return;
      }

      var backBtn = e.target.closest('[data-nav-back]');
      if (backBtn) {
        var vp2 = backBtn.closest('[data-nav-viewport]');
        if (vp2) showNavPanel(vp2, 'root');
      }
    });
  }

  /* ------------------------------------------------------------------ boot */

  function init(scope) {
    $$('[data-variant-picker]', scope || document).forEach(function (el) {
      if (!el.__lbBound) { el.__lbBound = true; new VariantPicker(el); }
    });
    $$('[data-product-root]', scope || document).forEach(function (el) {
      if (!el.__lbGalleryBound) { el.__lbGalleryBound = true; initProductGallery(el); }
    });
  }

  /* Process slideshow. The track is a scroll-snap row, so swiping works with no
     JS at all -- this only wires the arrows and dots on top of it. */
  function initProcessSlider() {
    var slider = $('[data-process-slider]');
    if (!slider) return;

    var track = slider.querySelector('[data-process-track]');
    var slides = $$('.process-slider__slide', slider);
    if (!track || slides.length < 2) return;

    // Controls and captions both sit outside the slider now (inside the page
    // gutters), so scope every lookup to the shared wrapper.
    var host = slider.closest('.product__process') || document;
    var prev = host.querySelector('[data-process-prev]');
    var next = host.querySelector('[data-process-next]');
    var dots = $$('[data-process-dot]', host);
    var captions = $$('[data-process-caption]', host);

    function current() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    function goTo(index) {
      var i = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }

    function sync() {
      var i = current();
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      captions.forEach(function (c, n) { c.classList.toggle('is-active', n === i); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
    }

    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        goTo(parseInt(d.getAttribute('data-process-dot'), 10) || 0);
      });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { sync(); ticking = false; });
    }, { passive: true });

    window.addEventListener('resize', sync);
    sync();
  }

  function boot() {
    relocatePanels();
    initProcessSlider();
    initHeader();
    initNavDrawer();
    init(document);
    updateCartCounts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor hooks */
  document.addEventListener('shopify:section:load', function (e) {
    relocatePanels(e.target);
    initProcessSlider();
    initHeader();
    init(e.target);
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-panel="cart"]')) {
      var p = getPanel('cart');
      if (p) p.open();
    }
  });
  document.addEventListener('shopify:section:deselect', function () { closeAllPanels(); });

  window.LB.addToCart = addToCart;
  window.LB.refreshCart = renderCartSections;
})();
